import React, { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import './RegistroCurso.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/moodle_inscripcion.php';
const APP = 'https://centrocomunicar.com/virtual';

/* ── Icons ── */
const IconCheck   = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrow   = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner = () => (<span style={{display:'inline-block',width:18,height:18,border:'2.5px solid rgba(130,216,179,.3)',borderTopColor:'#4db88a',borderRadius:'50%',animation:'rc-spin .7s linear infinite'}}/>);
const IconUser    = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBook    = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconShield  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const LogoComunicar = ({ height = 44 }) => (
  <svg height={height} viewBox="0 0 300 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="20" cy="28" rx="14" ry="12" fill="#82D8B3" opacity="0.7"/>
    <path d="M10 38 Q6 44 4 48 Q11 43 16 40Z" fill="#82D8B3" opacity="0.7"/>
    <ellipse cx="34" cy="22" rx="20" ry="17" fill="#82D8B3"/>
    <path d="M20 36 Q16 44 13 48 Q22 42 27 38Z" fill="#82D8B3"/>
    <circle cx="27" cy="22" r="2.2" fill="white"/>
    <circle cx="34" cy="22" r="2.2" fill="white"/>
    <circle cx="41" cy="22" r="2.2" fill="white"/>
    <text x="62" y="24" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="16" fill="#4db88a">Centro Comunicar</text>
    <text x="64" y="38" fontFamily="'DM Sans', sans-serif" fontWeight="400" fontSize="10" fill="#888">Comunicar – Lenguaje, Aprendizaje y Habla</text>
  </svg>
);

const PAISES = ['Perú','Argentina','Bolivia','Brasil','Chile','Colombia','Costa Rica','Cuba','Ecuador',
  'El Salvador','España','Guatemala','Honduras','México','Nicaragua','Panamá','Paraguay',
  'Puerto Rico','República Dominicana','Uruguay','Venezuela','Otro'];

const OCUPACIONES = ['Fonoaudiólogo/a','Terapeuta del lenguaje','Docente','Psicólogo/a',
  'Médico/a','Enfermero/a','Padre/Madre de familia','Estudiante universitario/a',
  'Terapeuta ocupacional','Otro profesional de salud','Otro'];

const PASOS = ['Términos', 'Datos personales', 'Confirmación'];

export default function RegistroCurso() {
  const [params]   = useSearchParams();
  const navigate   = useNavigate();
  const { estaLogueado, usuario } = useAuthUser();

  const pedidoId = parseInt(params.get('pedido') || '0');
  const token    = params.get('token') || '';

  const [paso,        setPaso]        = useState(1);
  const [verificando, setVerificando] = useState(true);
  const [pedidoInfo,  setPedidoInfo]  = useState(null);
  const [errorVerif,  setErrorVerif]  = useState('');
  const [enviando,    setEnviando]    = useState(false);
  const [errorEnvio,  setErrorEnvio]  = useState('');
  const [resultado,   setResultado]   = useState(null);

  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [yaInscrito,     setYaInscrito]     = useState(false);

  const [form, setForm] = useState({
    nombres:   '',
    apellidos: '',
    pais:      'Perú',
    ciudad:    '',
    ocupacion: '',
    email:     '',
    celular:   '',
  });

  /* ── Verificar pedido al cargar ── */
  useEffect(() => {
    if (!pedidoId || !token) {
      setErrorVerif('Enlace inválido o incompleto.');
      setVerificando(false);
      return;
    }
    fetch(`${API}?action=verificar_pedido&pedido_id=${pedidoId}&token=${token}`)
      .then(r => r.json())
      .then(j => {
        if (!j.success) throw new Error(j.message);
        setPedidoInfo(j.data);
        // Pre-rellenar con datos del usuario logueado o del pedido
        setForm(f => ({
          ...f,
          nombres:  usuario?.nombre  || j.data.nombre?.split(' ')[0] || '',
          apellidos:usuario?.apellido|| j.data.nombre?.split(' ').slice(1).join(' ') || '',
          email:    usuario?.email   || j.data.email   || '',
          celular:  usuario?.whatsapp|| '',
        }));
        // Si ya inscrito, saltar a confirmación
       
        /* if (j.data.ya_inscrito) {
          setResultado({ ya_inscrito: true, curso_nombre: j.data.curso_nombre,
            aula_url: `${APP}/course/view.php?id=${j.data.curso_id}` });
          return;
        } */

          if (j.data.ya_inscrito) setYaInscrito(true);



        // Si pago aún no validado, mostrar pantalla de espera
        if (j.data.estado === 'pendiente' || j.data.estado === 'voucher_enviado') {
          setErrorVerif('__PENDIENTE__:' + (j.data.curso_nombre || ''));
        }
      })
      .catch(e => setErrorVerif(e.message))
      .finally(() => setVerificando(false));
  }, [pedidoId, token]);

  function setF(k, v) { setForm(p => ({ ...p, [k]: v })); }

  function avanzarPaso1() {
    if (!aceptaTerminos) { setErrorEnvio('Debes aceptar los términos y condiciones para continuar.'); return; }
    setErrorEnvio('');
    // Si ya logueado, saltar formulario de datos
    
    setForm(f => ({
        ...f,
        nombres:   usuario?.nombre   || f.nombres,
        apellidos: usuario?.apellido || f.apellidos,
        email:     usuario?.email    || f.email,
        celular:   usuario?.whatsapp || f.celular,
      }));
      setPaso(2);



  }

  function validarPaso2() {
    if (!form.nombres.trim())   return 'El nombre es obligatorio';
    if (!form.apellidos.trim()) return 'Los apellidos son obligatorios';
    if (!form.email.includes('@')) return 'Email no válido';
    if (!form.ciudad.trim())    return 'La ciudad es obligatoria';
    if (!form.ocupacion)        return 'La ocupación es obligatoria';
    return '';
  }

  function avanzarPaso2() {
    const err = validarPaso2();
    if (err) { setErrorEnvio(err); return; }
    setErrorEnvio('');
    setPaso(3);
  }

  async function confirmarInscripcion() {
    setEnviando(true); setErrorEnvio('');
    try {
      const r = await fetch(`${API}?action=registrar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pedido_id:       pedidoId,
          token:           token,
          ...form,
          acepta_terminos: true,
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setResultado(j.data);
      setPaso(4);
    } catch(e) {
      setErrorEnvio(e.message);
    } finally {
      setEnviando(false);
    }
  }

  /* ── Loading verificación ── */
  if (verificando) {
    return (
      <div className="rc-page">
        <nav className="rc-nav"><Link to="/" className="rc-nav__logo"><LogoComunicar/></Link></nav>
        <div className="rc-loading"><IconSpinner/><p>Verificando tu pedido…</p></div>
      </div>
    );
  }

  /* ── Pantalla de espera (pago pendiente de validación) ── */
  if (errorVerif && errorVerif.startsWith('__PENDIENTE__:')) {
    const cursoNombrePend = errorVerif.replace('__PENDIENTE__:', '');
    return (
      <div className="rc-page">
        <nav className="rc-nav"><Link to="/" className="rc-nav__logo"><LogoComunicar/></Link></nav>
        <div className="rc-pendiente">
          <div className="rc-pendiente__icon">⏳</div>
          <h2>Pago en validación</h2>
          <p>Tu voucher está siendo revisado por el equipo de Comunicar.</p>
          <div className="rc-pendiente__curso">
            <span>🎓</span>
            <strong>{cursoNombrePend}</strong>
          </div>
          <div className="rc-pendiente__pasos">
            <div className="rc-pendiente__paso rc-pendiente__paso--done">
              <span>✓</span>
              <div>
                <strong>Pedido registrado</strong>
                <small>Código {pedidoId && `PED-2026-00${pedidoId}`}</small>
              </div>
            </div>
            <div className="rc-pendiente__paso rc-pendiente__paso--done">
              <span>✓</span>
              <div>
                <strong>Voucher recibido</strong>
                <small>En revisión por el equipo</small>
              </div>
            </div>
            <div className="rc-pendiente__paso rc-pendiente__paso--wait">
              <span>⏳</span>
              <div>
                <strong>Validación de pago</strong>
                <small>Generalmente en menos de 24h</small>
              </div>
            </div>
            <div className="rc-pendiente__paso rc-pendiente__paso--pending">
              <span>🔒</span>
              <div>
                <strong>Completar inscripción</strong>
                <small>Disponible tras la validación</small>
              </div>
            </div>
          </div>
          <div className="rc-pendiente__aviso">
            <p>📧 Recibirás un email con este mismo enlace cuando tu pago sea validado.</p>
            <p>También puedes volver a esta página más tarde — el enlace seguirá funcionando.</p>
          </div>
          <div className="rc-pendiente__btns">
            <a
              href={`https://wa.me/51940686868?text=${encodeURIComponent('Hola, acabo de enviar mi voucher de pago. ¿Cuándo validan mi acceso al curso?')}`}
              target="_blank" rel="noopener noreferrer"
              className="rc-btn-wa"
            >
              💬 Consultar por WhatsApp
            </a>
            <Link to="/" className="rc-btn-ghost">Volver al inicio</Link>
          </div>
        </div>
      </div>
    );
  }

  /* ── Error de verificación ── */
  if (errorVerif) {
    return (
      <div className="rc-page">
        <nav className="rc-nav"><Link to="/" className="rc-nav__logo"><LogoComunicar/></Link></nav>
        <div className="rc-error-page">
          <div className="rc-error-icon">⚠️</div>
          <h2>Enlace no válido</h2>
          <p>{errorVerif}</p>
          <Link to="/" className="rc-btn-primary">Volver al inicio</Link>
        </div>
      </div>
    );
  }

  /* ── Ya inscrito ── */
  if (resultado?.ya_inscrito) {
    return (
      <div className="rc-page">
        <nav className="rc-nav"><Link to="/" className="rc-nav__logo"><LogoComunicar/></Link></nav>
        <div className="rc-exito">
          <div className="rc-exito__icon" style={{background:'#dbeafe'}}>🎓</div>
          <h2>¡Ya estás inscrito!</h2>
          <p>Ya tienes acceso al curso <strong>{resultado.curso_nombre}</strong>.</p>
          <a href={resultado.aula_url} target="_blank" rel="noopener noreferrer" className="rc-btn-primary">
            Ir al aula virtual <IconArrow/>
          </a>
        </div>
      </div>
    );
  }

  /* ── Éxito ── */
  if (paso === 4 && resultado) {
    return (
      <div className="rc-page">
        <nav className="rc-nav"><Link to="/" className="rc-nav__logo"><LogoComunicar/></Link></nav>
        <div className="rc-exito">
          <div className="rc-exito__icon"><IconCheck/></div>
          <h2>¡Inscripción completada!</h2>
          <p>Bienvenido/a a <strong>{resultado.curso_nombre || pedidoInfo?.curso_nombre}</strong></p>
          <p className="rc-exito__sub">
            Te hemos enviado un email con tus credenciales de acceso al aula virtual.
            Revisa tu bandeja de entrada.
          </p>
          <div className="rc-exito__cards">
            <div className="rc-exito__card">
              <IconBook/>
              <div>
                <strong>Accede al curso</strong>
                <span>Tu inscripción ya está activa en el aula virtual</span>
              </div>
            </div>
            <div className="rc-exito__card">
              <IconUser/>
              <div>
                <strong>Credenciales por email</strong>
                <span>Revisa {form.email || pedidoInfo?.email}</span>
              </div>
            </div>
          </div>
          <div className="rc-exito__btns">
            <a href={resultado.aula_url} target="_blank" rel="noopener noreferrer" className="rc-btn-primary">
              🎓 Ir al aula virtual <IconArrow/>
            </a>
            <Link to="/" className="rc-btn-ghost">Volver al inicio</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rc-page">

      {/* NAV */}
      <nav className="rc-nav">
        <Link to="/" className="rc-nav__logo"><LogoComunicar/></Link>
      </nav>

      {/* HERO */}
      <div className="rc-hero">
        <div className="rc-hero__inner">
          <div className="rc-hero__badge">🎓 Inscripción al curso</div>
          <h1>{pedidoInfo?.curso_nombre}</h1>
          <p>Pedido <strong>{pedidoInfo?.codigo}</strong> · {pedidoInfo?.email}</p>
        </div>
      </div>

      {/* STEPS */}
      <div className="rc-steps-wrap">
        <div className="rc-steps">
          {PASOS.map((label, i) => (
            <div key={i} className={'rc-step ' + (paso===i+1?'rc-step--active':paso>i+1?'rc-step--done':'')}>
              <div className="rc-step__num">
                {paso > i+1 ? <IconCheck/> : i+1}
              </div>
              <span>{label}</span>
              {i < PASOS.length-1 && <div className="rc-step__line"/>}
            </div>
          ))}
        </div>
      </div>

      <div className="rc-card-wrap">

        {/* ════ PASO 1: TÉRMINOS ════ */}
        {paso === 1 && (
          <div className="rc-card">
            <div className="rc-card__head">
              <IconShield/>
              <div>
                <h2>Términos y condiciones</h2>
                <p>Léelos antes de completar tu inscripción</p>
              </div>
            </div>

            <div className="rc-terminos-box">
              <h3>Términos y condiciones de uso del Aula Virtual</h3>
              <p>Al inscribirte en este curso, aceptas las siguientes condiciones:</p>

              <h4>1. Uso personal e intransferible</h4>
              <p>El acceso al curso es personal e intransferible. No puedes compartir tus credenciales ni redistribuir el contenido del curso.</p>

              <h4>2. Propiedad intelectual</h4>
              <p>Todos los materiales, videos, recursos y contenidos del curso son propiedad de Comunicar – Desarrollo y Lenguaje. Queda prohibida su reproducción, distribución o uso comercial sin autorización expresa.</p>

              <h4>3. Certificación</h4>
              <p>El certificado de aprobación se emite a nombre del alumno registrado, con los datos exactos proporcionados en este formulario. Verifica que tu nombre y apellidos sean correctos.</p>

              <h4>4. Política de devoluciones</h4>
              <p>Una vez completada la inscripción y otorgado el acceso al curso, no proceden devoluciones. Consulta nuestra <Link to="/politica-devoluciones" target="_blank">política de devoluciones</Link> para más información.</p>

              <h4>5. Conducta en el aula</h4>
              <p>El alumno se compromete a mantener un comportamiento respetuoso dentro del aula virtual, tanto con los docentes como con otros participantes.</p>

              <h4>6. Tratamiento de datos personales</h4>
              <p>Los datos proporcionados serán utilizados exclusivamente para gestionar tu inscripción, emitir certificados y enviarte comunicaciones relacionadas con el curso. De acuerdo con la Ley 29733 (Perú), puedes solicitar la modificación o eliminación de tus datos contactándonos.</p>
            </div>

            {yaInscrito && (
              <div style={{background:'#dbeafe',border:'1px solid #93c5fd',borderRadius:10,padding:'.8rem 1rem',marginBottom:'1rem',fontSize:'.85rem',color:'#1d4ed8'}}>
                ℹ️ Ya estás inscrito en este curso. Puedes actualizar tus datos personales y se te enviará tu contraseña de acceso.
              </div>
            )}

            {errorEnvio && <div className="rc-error">{errorEnvio}</div>}

            <label className="rc-terminos-check">

              <input
                type="checkbox"
                checked={aceptaTerminos}
                onChange={e => { setAceptaTerminos(e.target.checked); setErrorEnvio(''); }}
              />
              <span>He leído y acepto los <strong>términos y condiciones</strong> y la <Link to="/politica-devoluciones" target="_blank">política de devoluciones</Link></span>
            </label>

            <div className="rc-card__foot">
              <button className="rc-btn-primary" onClick={avanzarPaso1} disabled={!aceptaTerminos}>
                Continuar <IconArrow/>
              </button>
            </div>
          </div>
        )}

        {/* ════ PASO 2: DATOS ════ */}
        {paso === 2 && (
          <div className="rc-card">
            <div className="rc-card__head">
              <IconUser/>
              <div>
                <h2>Datos personales</h2>
                <p>Se usarán para tu certificado y acceso al aula</p>
              </div>
            </div>

            {estaLogueado && (
              <div className="rc-aviso-logueado">
                <IconCheck/> Estás usando tu cuenta <strong>{usuario?.email}</strong>. Completa los datos para el certificado.
              </div>
            )}

            <div className="rc-form-grid">
              <div className="rc-field">
                <label>Nombres <span className="rc-req">*</span></label>
                <input type="text" placeholder="Ej: Ana María" value={form.nombres}
                  onChange={e => setF('nombres', e.target.value)}/>
                <small>Como aparecerá en tu certificado</small>
              </div>
              <div className="rc-field">
                <label>Apellidos <span className="rc-req">*</span></label>
                <input type="text" placeholder="Ej: García López" value={form.apellidos}
                  onChange={e => setF('apellidos', e.target.value)}/>
              </div>
              <div className="rc-field">
                <label>País <span className="rc-req">*</span></label>
                <select value={form.pais} onChange={e => setF('pais', e.target.value)}>
                  {PAISES.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              <div className="rc-field">
                <label>Ciudad <span className="rc-req">*</span></label>
                <input type="text" placeholder="Ej: Lima" value={form.ciudad}
                  onChange={e => setF('ciudad', e.target.value)}/>
              </div>
              <div className="rc-field rc-field--full">
                <label>Ocupación <span className="rc-req">*</span></label>
                <select value={form.ocupacion} onChange={e => setF('ocupacion', e.target.value)}>
                  <option value="">— Selecciona tu ocupación —</option>
                  {OCUPACIONES.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>
              <div className="rc-field">
                <label>Correo electrónico <span className="rc-req">*</span></label>
                <input type="email" placeholder="tu@correo.com" value={form.email}
                  onChange={e => setF('email', e.target.value)}/>
                <small>Se enviará tu acceso a este correo</small>
              </div>
              <div className="rc-field">
                <label>Celular / WhatsApp</label>
                <input type="tel" placeholder="+51 9XX XXX XXX" value={form.celular}
                  onChange={e => setF('celular', e.target.value)}/>
              </div>
            </div>

            {errorEnvio && <div className="rc-error">{errorEnvio}</div>}

            <div className="rc-card__foot">
              <button className="rc-btn-ghost" onClick={() => { setPaso(1); setErrorEnvio(''); }}>
                ← Anterior
              </button>
              <button className="rc-btn-primary" onClick={avanzarPaso2}>
                Continuar <IconArrow/>
              </button>
            </div>
          </div>
        )}

        {/* ════ PASO 3: CONFIRMAR ════ */}
        {paso === 3 && (
          <div className="rc-card">
            <div className="rc-card__head">
              <IconBook/>
              <div>
                <h2>Confirmar inscripción</h2>
                <p>Revisa tus datos antes de inscribirte</p>
              </div>
            </div>

            <div className="rc-resumen">
              <div className="rc-resumen__curso">
                <div className="rc-resumen__curso-icon">🎓</div>
                <div>
                  <p className="rc-resumen__label">Curso</p>
                  <strong>{pedidoInfo?.curso_nombre}</strong>
                </div>
              </div>
              <div className="rc-resumen__grid">
                {[
                  ['Nombre completo', `${form.nombres} ${form.apellidos}`],
                  ['Email',           form.email || pedidoInfo?.email],
                  ['Celular',         form.celular || '—'],
                  ['País / Ciudad',   `${form.pais} / ${form.ciudad}`],
                  ['Ocupación',       form.ocupacion || '—'],
                ].map(([label, val]) => (
                  <div key={label} className="rc-resumen__row">
                    <span>{label}</span>
                    <strong>{val}</strong>
                  </div>
                ))}
              </div>
            </div>

            <div className="rc-aviso-cert">
              <span>📜</span>
              <p>Tu certificado se emitirá con el nombre: <strong>{form.nombres} {form.apellidos}</strong>. Asegúrate de que sea correcto.</p>
            </div>

            {errorEnvio && <div className="rc-error">{errorEnvio}</div>}

            <div className="rc-card__foot">
            <button className="rc-btn-ghost" onClick={() => { setPaso(2); setErrorEnvio(''); }}>
                ← Anterior
              </button>
              <button className="rc-btn-primary rc-btn-primary--grande" onClick={confirmarInscripcion} disabled={enviando}>
                {enviando ? <><IconSpinner/> Inscribiendo…</> : <>🎓 Confirmar inscripción</>}
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}